import { useTranslation } from 'react-i18next';
import * as yup from 'yup';

// 0-9, (), +, or -
const phoneRexex = /[0-9+()-]*/;
// 00-00-0000
const dateRegex = /^([0-9][0-9])-([0-9][0-9])-\d{4}$/;

export const useValidationSchema = () => {
    const { t } = useTranslation();

    return yup.object().shape({
        birthdate: yup
            .string()
            .matches(dateRegex, t('validation.dateNotValid') as string)
            .required(t('validation.date') as string),
        relocationDate: yup
            .string()
            .matches(dateRegex, t('validation.dateNotValid') as string)
            .required(t('validation.date') as string),
        salutation: yup.string(),
        firstName: yup.string().required(t('validation.firstName') as string),
        lastNamePrefix: yup.string(),
        lastName: yup.string().required(t('validation.lastName') as string),
        customerEmail: yup
            .string()
            .email(t('validation.emailNotValid') as string)
            .required(t('validation.email') as string),
        phoneNumber: yup
            .string()
            .matches(phoneRexex, t('validation.phoneNotValid') as string)
            .required(t('validation.phone') as string),
        street: yup.string().required(t('validation.street') as string),
        newStreet: yup.string().required(t('validation.street') as string),
        houseNumber: yup
            .string()
            .required(t('validation.houseNumber') as string),
        newHouseNumber: yup
            .string()
            .required(t('validation.houseNumber') as string),
        houseNumberAddition: yup.string(),
        newHouseNumberAddition: yup.string(),
        zipcode: yup.string().required(t('validation.zipcode') as string),
        newZipcode: yup.string().required(t('validation.zipcode') as string),
        city: yup.string().required(t('validation.city') as string),
        newCity: yup.string().required(t('validation.city') as string),
        store: yup.string().required(t('validation.store') as string),
        storeTwo: yup.string(),
    });
};
